import React from 'react';
import { Button } from '@mantine/core';

// Renders the 3-4 action buttons for user(s) selected in the friends
// interaction UI. Shared by the ArtPage inline strip and the
// FollowingDropdown drawer so both surfaces stay in lockstep.
export const renderArtUserActionButtons = ({
  selectedUsers,
  language,
  hasEvent,
  hasRecommendationFromMe,
  hasRecommendationToMe,
  recommendationsFromMeMap,
  recommendationsToMeMap,
  messagesSentToUser,
  sendingToUser,
  navigate,
  handleRecommend,
  navigateToDiscussion,
  sendArtLinkToUser,
  goToDirectChat,
  getUserName,
}) => {
  if (selectedUsers.length === 1) {
    const single = selectedUsers[0];
    return [
      hasEvent(single) && (() => {
        const name = getUserName?.(single);
        return (
          <Button
            key="disc"
            variant="filled"
            color="green"
            size="xs"
            fullWidth
            styles={{ root: { height: 39 } }}
            onClick={() => navigateToDiscussion(single)}
          >
            {language === "ru"
              ? `Перейти в библиотеку${name ? ` ${name}` : ""}`
              : `Go to library${name ? ` of ${name}` : ""}`}
          </Button>
        );
      })(),
      hasRecommendationFromMe(single) && (
        <Button
          key="fromMeRec"
          variant="filled"
          color="blue"
          size="xs"
          fullWidth
          styles={{ root: { height: 39 } }}
          onClick={() => navigate(`/recommendations/${recommendationsFromMeMap[single]}`)}
        >
          {language === "ru" ? "Перейти к моей рекомендации" : "Go to my recommendation"}
        </Button>
      ),
      hasRecommendationToMe(single) && (
        <Button
          key="toMeRec"
          variant="filled"
          color="blue"
          size="xs"
          fullWidth
          styles={{ root: { height: 39 } }}
          onClick={() => navigate(`/recommendations/${recommendationsToMeMap[single]}`)}
        >
          {language === "ru" ? "Перейти к рекомендации от пользователя" : "Go to recommendation from user"}
        </Button>
      ),
      !hasRecommendationFromMe(single) && (
        <Button
          key="rec"
          variant="filled"
          color="blue"
          size="xs"
          fullWidth
          styles={{ root: { height: 39 } }}
          onClick={() => handleRecommend([single])}
        >
          {language === "ru" ? "Рекомендовать" : "Recommend"}
        </Button>
      ),
      messagesSentToUser[single] ? (
        <div
          key="msgSent"
          role="button"
          tabIndex={0}
          onClick={() => goToDirectChat(single)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') goToDirectChat(single);
          }}
          className="cursor-pointer text-center rounded flex flex-col justify-center"
          style={{
            background: 'var(--mantine-color-blue-filled)',
            color: 'white',
            height: 39,
            padding: '4px 8px',
          }}
        >
          <div className="text-[10px] leading-none opacity-90">
            {language === "ru" ? "Сообщение отправлено" : "Message sent"}
          </div>
          <div className="text-xs font-semibold leading-tight mt-0.5">
            {language === "ru" ? "Перейти в чат →" : "Go to chat →"}
          </div>
        </div>
      ) : (
        <Button
          key="writeMsg"
          variant="filled"
          color="blue"
          size="xs"
          fullWidth
          styles={{ root: { height: 39 } }}
          loading={sendingToUser === single}
          onClick={() => sendArtLinkToUser(single)}
        >
          {language === "ru" ? "Отправить в сообщении" : "Send in a message"}
        </Button>
      ),
    ].filter(Boolean);
  }
  if (
    selectedUsers.length > 1 &&
    selectedUsers.every((userId) => !hasRecommendationFromMe(userId))
  ) {
    return [
      <Button
        key="recSep"
        variant="filled"
        color="blue"
        size="xs"
        fullWidth
        onClick={() => handleRecommend(selectedUsers)}
      >
        {language === "ru" ? "Рекомендовать отдельно" : "Recommend separately"}
      </Button>,
    ];
  }
  return [];
};
